module.exports = __webpack_public_path__ + "static/media/hero.c5126f14.png";